export { default } from './textarea'
export type { TProps as TextareaProps } from './textarea'
